/**
 * Metadado das plataformas de pixel, num lugar só. O card e o formulário
 * mostravam rótulo e cor cada um da sua cópia, e bastava editar um deles para as
 * duas telas discordarem sobre o mesmo pixel.
 */
const platforms = [
    {
        value: 'meta',
        label: 'Meta',
        hint: 'Facebook e Instagram',
        color: '#1877F2',
        idPlaceholder: 'Ex: 123456789012345',
        idFormat: 'Só dígitos, de 10 a 20.',
        supportsConversionApi: true,
    },
    {
        value: 'google',
        label: 'Google',
        hint: 'Ads e Analytics',
        color: '#4285F4',
        idPlaceholder: 'Ex: G-AB12CD34EF',
        idFormat: 'Começa com G-, AW-, GTM-, UA- ou DC-.',
        // O Google Ads registra conversão pela Ads API, com credencial de OAuth
        // em vez do token de pixel que o produtor cadastra aqui.
        supportsConversionApi: false,
    },
    {
        value: 'tiktok',
        label: 'TikTok',
        hint: 'TikTok Ads',
        color: '#111111',
        idPlaceholder: 'Ex: C4A1B2C3D4E5F6G7H8I9',
        idFormat: 'De 10 a 30 letras e números.',
        supportsConversionApi: true,
    },
];

export function findPlatform(value) {
    return platforms.find(platform => platform.value === value) || null;
}

export function platformLabel(value) {
    return findPlatform(value)?.label || value;
}

export default platforms;
